import { CapitalizeFirstWord } from "../../helpers/CustomFileUpoader";

export interface IState {
  contactsList: any;
  customerList: any;
  contactsCount: number;
  contactsCompanies: any;
  contactLastId: any;
  singleContact: any;
  associatedRecord: any;
  contactsVendorList: any;
}

type Action = any;

export const contactsReducer = (
  state: IState = {
    contactsList: [],
    customerList: [],
    contactsCount: 0,
    contactsCompanies: [],
    contactLastId: "",
    singleContact: null,
    associatedRecord: [],
    contactsVendorList: [],
  },
  action: Action
): any => {
  switch (action.type) {
    case "GET_CONTACTS":
      return {
        ...state,
        contactsList:
          action?.payload?.page == 1 ? action?.payload?.data : [...state?.contactsList, ...action?.payload?.data],
        contactsCount: action?.payload?.count,
      };
    case "GET_CUSTOMER":
      return {
        ...state,
        customerList:
          action?.payload?.page == 1 ? action?.payload?.data : [...state?.customerList, ...action?.payload?.data],
        // contactsCount: action?.payload?.count,
      };

    case "GET_VENDOR_CONTACTS":
      return {
        ...state,
        contactsVendorList:
          action?.payload?.page == 1 ? action?.payload?.data : [...state?.contactsVendorList, ...action?.payload?.data],
        contactsCount: action?.payload?.count,
      };
    case "UPLOAD_DOCUMENT":
      return {
        ...state,
        contactsList: state?.contactsList?.map((elem: any) => {
          if (elem?._id == action?.payload?.data?._id) {
            return { ...elem, documents: action?.payload?.data?.documents };
          }
          return elem;
        }),
      };

    case "GET_CONTACTS_COMPANIES":
      return {
        ...state,
        contactsCompanies: action?.payload,
      };

    case "GET_CONTACTS_ID":
      const newEsNumber = Number(action?.payload) + 1;
      return {
        ...state,
        contactLastId: newEsNumber ?? 1,
      };
    case "GET_SINGLE_CONTACTS":
      return {
        ...state,
        singleContact: action?.payload?.data[0],
      };
    case "GET_ASSOCIATE_RECORD":
      return {
        ...state,
        associatedRecord:
          action?.payload?.page == 1 ? action?.payload?.data : [...state?.associatedRecord, ...action?.payload?.data],
      };
    case "CLEAR_BOAT_CUSTOMER_DATA":
      return {
        ...state,
        contactsList: [],
      };
    case "UPDTAE_CUSTOMER_LOGIN":
      return {
        ...state,
        singleContact: { ...state?.singleContact, allow_login: action?.payload },
      };
    case "UPDTAE_MEMBER_DATA":
      const updatedTeamMeber = state?.singleContact?.team_members?.map((elem: any) => {
        if (elem?._id == action?.payload?._id) {
          return {
            ...action?.payload,
            full_name: `${CapitalizeFirstWord(action?.payload?.first_name)} ${CapitalizeFirstWord(action?.payload?.last_name)}`,
          };
        }
        return elem;
      });
      return {
        ...state,
        singleContact: { ...state?.singleContact, team_members: updatedTeamMeber },
      };

    case "ADD_TEAM_MEMBER_DATA":
      const addedTeamMember = [
        ...state?.singleContact?.team_members,
        {
          ...action?.payload,
          full_name: `${CapitalizeFirstWord(action?.payload?.first_name)} ${CapitalizeFirstWord(action?.payload?.last_name)}`,
        },
      ];
      return {
        ...state,
        singleContact: { ...state?.singleContact, team_members: addedTeamMember },
      };

    case "DELETE_TEAM_MEMEBR":
      const deletedTeamMeber = state?.singleContact?.team_members?.filter((elem: any) => elem?._id != action?.payload);
      return {
        ...state,
        singleContact: { ...state?.singleContact, team_members: deletedTeamMeber },
      };

    default:
      return state;
  }
};
